import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "none",
  viewBox: "0 0 100.71 100.71"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m.35.35 100 100M100.35.35l-100 100",
  "vector-effect": "non-scaling-stroke"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }